import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useMapStore } from '../store/useMapStore';
import { useTranslation } from '../i18n/translations';

const LocatingOverlay: React.FC = () => {
  const isLocating = useMapStore(state => state.isLocating);
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {isLocating && (
        <div className="locating-overlay-container">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="glass-heavy locating-overlay"
          >
            <img src="/branding/location-mascot.webp" alt="N-Bot" className="hero-mascot" />
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <h2 className="locating-text">{t('LOCATE_ME')}</h2>
              <p className="locating-subtext">
                {t('LOCATING_SUBTEXT')}
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              background: 'rgba(14, 165, 233, 0.1)',
              padding: '8px 16px',
              borderRadius: '12px',
              marginTop: '10px'
            }}>
              <Loader2 className="animate-spin" size={16} color="var(--accent)" />
              <span style={{ fontSize: '12px', fontWeight: 700, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '1px' }}>
                {t('GPS_ACTIVE')}
              </span>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default LocatingOverlay;
